import { render, staticRenderFns } from "./BetTable.vue?vue&type=template&id=a7ebf6f2&"
import script from "./BetTable.vue?vue&type=script&lang=js&"
export * from "./BetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports